"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _Layout = require("./Layout");

var Message = function Message() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Layout.Container, {
    icon: /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], {
      className: "text-gray-light",
      fontSize: "small"
    })
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold text-sm"
  }, t('message.readReceiptBlocking.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs"
  }, t('message.readReceiptBlocking.body')));
};

exports.Message = Message;
//# sourceMappingURL=ReadReceiptBlocking.js.map